import { Component } from '@angular/core';
import { NavController, Events, App, LoadingController, NavParams } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { ProductDetailCommon } from './product-detail.common';
import { ProductData } from '../../providers/product-data';
// import { Observable } from 'rxjs/Observable';
import { WeeklyAdPageFull } from './../../../weekly-ad/pages/weekly-ad/weekly-ad.full';

@Component({
	selector: 'page-product-detail-full',
  	templateUrl: 'product-detail.full.html'
})

export class ProductDetailPageFull extends PageBaseFull {
	public loader: any;
	public productId: any;
	public productDetail = {};

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: ProductDetailCommon,
		public app: App,
		public productData: ProductData,
		public loadingCtrl: LoadingController,
		private navParams: NavParams
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		this.productId = navParams.get('id');
	}
	
	ionViewDidEnter() {
		this.app.setTitle('Smart App | Product Detail');
		this.appendFooterScripts('assets-full/base/js/scripts/pages/isotope-grid.js');
	}

	ngAfterViewInit() {
		//this.common.commonMethod();	
		//console.log(this.productId);
		this.loadData();
	}

	loadData() {
		if (this.productId !== undefined){
			var self = this;
			self.loader = this.loadingCtrl.create();
			self.loader.present();

			self.productData.getProductDetail(this.productId).subscribe(product => {
				console.log(product);
				this.productDetail = product;
			});
			self.loader.dismiss();
		}else{
			this.nav.push(WeeklyAdPageFull, { categoryUrlSlug: 'all', showHideCategories: true });
		}
		
	}

	public addToCart(id){
		console.log(id);
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/pages/product-detail/product-detail.full.ts